import { render } from "./LastTransactionsList.vue?vue&type=template&id=33e56529&scoped=true"
import script from "./LastTransactionsList.vue?vue&type=script&lang=js"
export * from "./LastTransactionsList.vue?vue&type=script&lang=js"

import "./LastTransactionsList.vue?vue&type=style&index=0&id=33e56529&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e56529"]])

export default __exports__